import { useFirestoreID } from "../../../firebase/useFirestore";
import Tooltip from "../../common/Tooltip";
import AnalyticsEmptyState from "../../dashboard/AnalyticsEmptyState";
import useChartColors from '../../../hooks/useChartColors';
import useSettings from "../../../hooks/Settings";

const NumberMomentVisualisation = ({ data, field, totalRespondents, projectHierarchy, projectAverages, source='questionnaire', primaryColorOverride }) => {
   // Hooks
    // palette[0] is de huisstijl binnen een live rapportage en de vaste
    // paletkleur daarbuiten — zie docs/patterns.md#ui-chart-palette.
    const { palette } = useChartColors();
    // useSettings blijft nodig voor `portfolio` — dat is geen kleur.
    const settings = useSettings();
    const primaryColor = palette[0];
    const h1Color = primaryColorOverride || primaryColor;
    // Per-project results are portfolio-only — child projects don't exist elsewhere.
    const showProjectResults = settings?.portfolio === 'block' && Boolean(projectHierarchy) && Boolean(projectAverages);

    // Firestore
    const fields = useFirestoreID(source === 'event' ? "EventFields" : "QuestionnaireFields", field || "");

    // Prepare project results for tooltip
    const projectResults = () => {
        if (!projectHierarchy || !projectAverages) return null;

        const sortedProjects = Object.entries(projectHierarchy).sort(
            ([, a], [, b]) => (a?.path || '').localeCompare(b?.path || '')
        );

        return (
            <div className="scale-visualisation-project-results-container" style={{ whiteSpace: 'nowrap' }}>
                {sortedProjects.map(([name, info], idx) => (
                    <div key={idx} style={{ paddingLeft: `${info.depth * 10}px` }}>
                        <p>
                            {name}: {projectAverages[name] ?? '–'}
                        </p>
                    
                    </div>
                ))}
            </div>
        );
    };

    return (
        <>
            <div id="scale-visualisation-title-container">
                <h2>Gemiddelde score</h2>
            </div>
            <div id="scale-visualisation-scale-container">
                {/* Map over fields and match with groupedData */}
                {fields && data?.groupedData ? (
                    fields.map((fieldItem, index) => {
                        // Safely access the average score
                        const averageScore = parseFloat(data.groupedData[index]?.average) || 0;

                        return (
                            <div key={fieldItem.ID} id="scale-visualisation-scale-item-container">
                                <div id="scale-visualisation-avarage-score-item-container">
                                    {showProjectResults ? (
                                        <Tooltip content={projectResults()} top='80px' width='30px' left={'-50px'}>
                                            <h1 style={{ color: h1Color }}>
                                                {averageScore.toFixed(1)}
                                            </h1>
                                        </Tooltip>
                                    ) : (
                                        <h1 style={{ color: h1Color }}>
                                            {averageScore.toFixed(1)}
                                        </h1>
                                    )}
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <AnalyticsEmptyState />
                )}
            </div>
        </>
    );
}

export default NumberMomentVisualisation